var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// 由于不同的端 IdentityVerification不一样，需要由具体代码包传入实现“端无关”
export default function (startIdentityVerification) {
    function withVerification(requestFn) {
        function verificationRequestFn(config) {
            var _a = config.verificationEnabled, verificationEnabled = _a === void 0 ? true : _a, restConfig = __rest(config, ["verificationEnabled"]);
            return requestFn(restConfig).catch(function (err) {
                var _a = err, result = _a.result, error_url = _a.error_url;
                if (verificationEnabled && result >= 400001 && result <= 410999 && error_url) {
                    return startIdentityVerification({
                        url: error_url,
                        result: result,
                    })
                        // 验证错误还是抛出接口的错误
                        .catch(function () {
                        return Promise.reject(err);
                    })
                        .then(function (verRes) {
                        var _a = verRes || {}, result = _a.result, type = _a.type, token = _a.token;
                        if (result === 1) {
                            return verificationRequestFn(__assign(__assign({}, config), { params: __assign(__assign({}, (config.params || {})), { ztIdentityVerificationType: type, ztIdentityVerificationCheckToken: token }) }));
                        }
                        // 其他异常情况不用考虑
                        return Promise.reject(err);
                    });
                }
                return Promise.reject(err);
            });
        }
        return verificationRequestFn;
    }
    return withVerification;
}
;
//# sourceMappingURL=index.js.map